import React from 'react';
import * as request from '../../utils/request';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-bootstrap';
import { formValueSelector } from 'redux-form';
import * as runActions from '../../actions/runsActionCreators';
import * as commonActions from '../../actions/commonActions';
import { browserHistory } from 'react-router';
import AdminSteps from '../common/AdminSteps';
import label from '../../utils/lngEn';
import moment from 'moment';
import PublishAssignmentForm from './PublishAssignmentForm';
import { delay } from 'lodash';
import toastr from 'toastr';
import Spinner from 'react-spinkit';

class PublishAssignmentPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isPublishing: false,
      assignmentPublished: false
    };
  }

  componentWillMount() {
    let auth = localStorage.getObject('auth');
    if (auth) {
      this.props.runActions.getRun();
    } else {
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/' + localStorage.getItem('login'));
    }
  }

  componentDidMount() {
    const publishingStatus = JSON.parse(localStorage.getItem('publishingStatus')) || {};
    if (publishingStatus.status === 'pending') {
      this.setState({ isPublishing: true });
      const statusUrl = publishingStatus.url;
      this.checkPublishingStatus(statusUrl);
    }
    this.props.runActions.getFinishedComputations();
  }

  parseAssignmentsOptions = (assignmentIds = []) =>
    assignmentIds.map(item => ({
      option: `Computation ${item.id} - ${moment(item.created_at).format('ll')}`,
      value: item.id
    }));

  checkPublishingStatus = url => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', url)
        .then(response => {
          if (response.data.status === 'success') {
            this.setState({ isPublishing: false, assignmentPublished: true });
            localStorage.removeItem('publishingStatus');
            return resolve(response.data.output);
          } else {
            delay(() => {
              resolve(this.checkPublishingStatus(url));
            }, 1000)
          }
        })
        .catch(error => {
          console.log(error);
          toastr.error('Error while publishing ');
          return reject('Error');
        });
    });
    return promise;
  };

  handlePublishComputation = () => () => {
    const { currentComputationId } = this.props;
    const activeId = currentComputationId.value ? currentComputationId.value : currentComputationId;
    const { email_students = false, populate_waitlist = false } = this.props;
    toastr.info('Publish assignment is starting...');
    this.setState({ isPublishing: true });
    this.props.runActions
      .publishComputations(activeId, email_students, populate_waitlist)
      .then(async data => {
        localStorage.setItem('publishingStatus', JSON.stringify(data));
        const statusUrl = data.url;
        const finalOutput = await this.checkPublishingStatus(statusUrl);
        if (finalOutput != null) return this.backToAssignment()
      })
      .catch(error => toastr.error(error.error));
  };

  backToAssignment = () => {
    const runName = localStorage.getItem('run');
    browserHistory.push(`/administer/${runName}/assignment/`);
  };

  render() {
    const { finished_computations } = this.props.run;
    const computations = finished_computations
      ? this.parseAssignmentsOptions(this.props.run.finishedComputations).reverse()
      : [];
    const computationId = computations[0] ? computations[0].value : 0;
    const assignmentFormInitialValues = {
      computationId: computationId
    };
    const { assignment_complete } = this.props.run;
    if (assignment_complete) return this.backToAssignment();
    const { isPublishing } = this.state;
    return (
      <Col md={12}>
        <div className="page-title">{label.publishAssignment}</div>
        <AdminSteps active="0" label={this.props.run.slug} />
        <Row>
          <Col md={6}>
            <div>
              {isPublishing ? (
                <div className="spinner-box">
                  <h3 className="text-center mb-3">Publishing assignment...</h3> <Spinner spinnerName="three-bounce" />
                </div>
              ) : (
                <div>
                  <h3>Publish assignment of student schedules?</h3>
                  <p>
                    This will close the Assignment Period and open the Add/Drop Period using an assignment of student
                    schedules that you select
                  </p>
                  {assignmentFormInitialValues.computationId ? (
                    <PublishAssignmentForm
                      computations={computations}
                      initialValues={assignmentFormInitialValues}
                      handleCancel={this.backToAssignment}
                      handlePublishComputation={this.handlePublishComputation()}
                    />
                  ) : null}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Col>
    );
  }
}

function mapStateToProps(state) {
  const assignmentFormSelector = formValueSelector('PublishAssignmentForm');
  return {
    run: state.run,
    form: state.form,
    currentComputationId: assignmentFormSelector(state, 'computationId'),
    email_students: assignmentFormSelector(state, 'email_students'),
    populate_waitlist: assignmentFormSelector(state, 'populate_waitlist')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishAssignmentPage);



// WEBPACK FOOTER //
// ./src/components/runs/PublishAssignmentPage.js